import { EntityType } from "../../types/EntityType";
import {
  ALL_ROLES,
  UPDATE_PACKAGE_AGREEMENTS_ROLE,
  UPDATE_PACKAGE_PRODUCTS_ROLE,
  UPDATE_PACKAGE_WORKS_ROLE,
} from "../../Consts";

export interface IAddToPackagePermissionParams {
  roles?: string[];
  entityType: EntityType;
  addToPackages?: unknown;
  tableContentItem?: any;
  enforceRole?: boolean;
}

export const hasAddToPackageRole = (
  roles: string[] = [],
  requiredRole: string,
): boolean => {
  return roles.includes(ALL_ROLES) || roles.includes(requiredRole);
};

export const getAddToPackageRequiredRole = (
  entityType: EntityType,
): string | null => {
  switch (entityType) {
    case EntityType.Work:
      return UPDATE_PACKAGE_WORKS_ROLE;
    case EntityType.Agreements:
      return UPDATE_PACKAGE_AGREEMENTS_ROLE;
    case EntityType.Products:
      return UPDATE_PACKAGE_PRODUCTS_ROLE;
    default:
      return null;
  }
};

export const isAddToPackageDisabled = ({
  roles = [],
  entityType,
  addToPackages,
  tableContentItem,
  enforceRole = true,
}: IAddToPackagePermissionParams): boolean => {
  if (!addToPackages) {
    return true;
  }

  const productType = tableContentItem?.productType ?? tableContentItem?.type;
  if (entityType === EntityType.Products && productType !== "CUE SHEET")
  {
    return true;
  }

  if (!enforceRole) {
    return false;
  }

  const requiredRole = getAddToPackageRequiredRole(entityType);

  if (!requiredRole) {
    return true;
  }

  return !hasAddToPackageRole(roles, requiredRole);
};
